import { initialTableData } from "../DataModelConfig/DataTest";

export const TablesModelList = [
  // {
  //   modelId: "model-1",
  //   modelLabel: "Model 1",
  //   data: initialTableData,
  // },
  // {
  //   modelId: "model-2",
  //   modelLabel: "Model 2",
  //   data: initialTableData,
  // },
  // {
  //   modelId: "model-3",
  //   modelLabel: "Model 3",
  //   data: initialTableData,
  // },

  {
    modelId: "model-list-simple",
    modelLabel: "Model Lista e Thjeshte",
    data: initialTableData,
  },
  {
    modelId: "model-list-oshma",
    modelLabel: "Model Lista e Oshma",
    data: initialTableData,
  },
  {
    modelId: "model-popullata",
    modelLabel: "Model Lista e Popullates",
    data: initialTableData,
  },
  {
    modelId: "model-program-list",
    modelLabel: "Model Lista e Programeve",
    data: initialTableData,
  },
  {
    modelId: "model-reklama-bleresit",
    modelLabel: "Model Lista e Bleresve te Reklameve",
    data: initialTableData,
  },
  {
    modelId: "model-reklama-sekonda",
    modelLabel: "Model Lista e Kohes te Reklameve",
    data: initialTableData,
  },
  {
    modelId: "model-shareholding",
    modelLabel: "Model Lista e Aksonerve OSHMA",
    data: initialTableData,
  },
  {
    modelId: "model-shtojca-1",
    modelLabel: "Tema e Lajmit Model Lista Shtojca 1",
    data: initialTableData,
  },
  {
    modelId: "model-shtojca-2",
    modelLabel: "Subjektet politike Model Lista Shtojca 2",
    data: initialTableData,
  },
  {
    modelId: "model-shtojca-3",
    modelLabel: "Institucinet Model Lista Shtojca 3",
    data: initialTableData,
  },
  {
    modelId: "model-shtojca-4",
    modelLabel: "Protagonistët Model Lista Shtojca 4",
    data: initialTableData,
  },
  {
    modelId: "model-text-dot-value",
    modelLabel: "Model Tekst....Vlere",
    data: initialTableData,
  },
  {
    modelId: "model-vleresim-gjinor-1",
    modelLabel: "Model Vleresim Gjinor 1",
    data: initialTableData,
  },
  {
    modelId: "model-vleresim-gjinor-2",
    modelLabel: "Model Vleresim Gjinor 2",
    data: initialTableData,
  },
];
